module.exports = __webpack_public_path__ + "static/media/prenda6-min.420300c1.jpg";